import { message } from "antd";
import { useAppSelector } from "features/common/hooks/useReduxHooks";
import { request } from "libs/axios";
import { useMutation, useQueryClient } from "react-query";

export interface MutateFunctionInterface {
  token: string | null;
  id: number | string;
}

const mutateFunction = async ({ id, token }: MutateFunctionInterface) => {
  //TODO - change api
  return request({
    url: `auth/users/${id}`,
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const useDeleteUserApi = () => {
  const { currAppToken } = useAppSelector((state) => state.appsAuth);
  const queryClient = useQueryClient();

  return useMutation(
    "users/delete",
    (id: string) => {
      return mutateFunction({ id, token: currAppToken });
    },
    {
      onSuccess: async (response) => {
        message.success(response.data.message);
        queryClient.invalidateQueries([`getAllUsers`]);
      },
    }
  );
};
